// Alakzatfelismerő (/alakzatfelismero) és Gyertyaminta-felismerő (/gyertyafelismero): egy motor
// (components/alakzat/AlakzatQuiz), két készlet. Készletenként itt van minden szöveg és belépési pont.
// A szintbeosztás NEM itt van: az adatbázisban, az alakzat_feladatok.min_szint és .demo oszlopban
// (készletenként, a szerver dönt, kód nélkül állítható). A feladatok a szerverről jönnek, a keszlet
// paraméterrel (landing migráció 20261120120000_gyertyafelismero_1).
import { REGISTER_FROM_ALAKZAT_URL, REGISTER_FROM_GYERTYA_URL } from './links';

const DISCLAIMER = 'Oktatási gyakorló múltbeli adatokon, nem befektetési tanács.';
const FORRAS = 'Valós, névtelenített BTC/USD részletek (Bitstamp, 2014–2026)';

export const KESZLETEK = {
  alakzat: {
    keszlet: 'alakzat',
    ev: 'alakzat',                 // az események előtagja: alakzat_kor_start, …
    hibaElotag: '',                // a kliens hibájának helye a hibanaplóban (alakzat_hiba)
    path: '/alakzatfelismero',
    cim: 'Alakzatfelismerő',
    alcim: 'Valós BTC-grafikonok, a kitörés előtt megállítva. Melyik alakzat rajzolódik ki?',
    statCim: 'Alakzatonként',
    statSzo: 'alakzatonkénti',     // „… alakzatonkénti statisztikával”
    hibaSzo: 'alakzatnál',         // „… melyik alakzatnál hibázol”
    kerdes: 'Melyik alakzat tankönyvi feltételei teljesülnek ezen a részleten?',
    szabalyok: [
      'A részlet a kitörés előtti utolsó gyertyánál ér véget; dátum, ár és rajzolt vonal nincs rajta.',
      'Mindig az a kérdés, melyik alakzat tankönyvi feltételei teljesülnek, sosem az, hogy merre megy az ár.',
      'A „nincs egyértelmű alakzat” is lehet helyes válasz.',
    ],
    jelmagyarazat: [
      'türkiz szaggatott vonal: az alakzat vonalai',
      'narancs pontozott vonal, x-szel: az érvénytelenítési szint',
      'türkiz pontok és betűk: a fontos csúcsok és mélypontok',
    ],
    nincs: 'nincs egyértelmű alakzat',
    nincsItelet: 'Nem egészen. Itt nincs egyértelmű alakzat.',
    gyertyaSzam: true,             // a feladat fölötti sorban: „4 órás grafikon · 42 gyertya”
    osszes: 158,
    demoFree: 12,                  // a regisztráció után ennyi feladat érhető el
    demoCim: 'Felismered az alakzatot?',
    demoAlcim: 'Öt valós BTC-grafikon, a kitörés előtt megállítva. Regisztráció nélkül.',
    registerUrl: REGISTER_FROM_ALAKZAT_URL,
    // Kripto Start 9. modul („Diagram Minták Olvasása”: mind a 10 alakzatot tanítja)
    moduleIds: ['ead81be0-3c10-4246-b9ca-55e1f5923463'],
    slugs: ['alakzatfelismero-gyakorlofuzet'],   // „Interaktív változat” ezeknél a segédleteknél
    ikon: '📐',
    linkSor: 'Valós BTC-grafikonok a kitörés előtt: melyik alakzat rajzolódik ki?',
    forras: FORRAS,
    disclaimer: DISCLAIMER,
  },
  gyertya: {
    keszlet: 'gyertya',
    ev: 'gyertya',
    hibaElotag: 'gyertya_',
    path: '/gyertyafelismero',
    cim: 'Gyertyaminta-felismerő',
    alcim: 'Valós BTC-grafikonok, a minta utolsó gyertyájánál megállítva. Melyik minta ez, ezen a helyen?',
    statCim: 'Mintánként',
    statSzo: 'mintánkénti',
    hibaSzo: 'mintánál',
    kerdes: 'Melyik gyertyaminta ez, ezen a helyen?',
    szabalyok: [
      'A grafikon a minta utolsó gyertyájánál ér véget; a kijelölés a minta egy, két vagy három gyertyáját fogja közre.',
      'Nézd meg az előtte lévő mozgást is: ugyanaz az alak csökkenés után mást jelent, mint emelkedés után.',
      'A „nincs érvényes minta” is lehet helyes válasz: oldalazás közepén a fordulóminta nem számít.',
    ],
    jelmagyarazat: [
      'türkiz keret: a minta gyertyái',
      'narancs szaggatott vonal: az előtte lévő csökkenés vagy emelkedés',
      'narancs pontozott vonalak: az oldalazás sávja',
    ],
    nincs: 'nincs érvényes minta',
    nincsItelet: 'Nem egészen. Itt nincs érvényes minta.',
    gyertyaSzam: false,            // mindig 22 gyertya: csak az idősík („napi grafikon”)
    osszes: 157,
    demoFree: 12,
    demoCim: 'Felismered a gyertyamintát?',
    demoAlcim: 'Öt valós BTC-grafikon. Ugyanaz az alak más helyen mást jelent. Regisztráció nélkül.',
    registerUrl: REGISTER_FROM_GYERTYA_URL,
    // Kripto Start 8. modul („Gyertyák Elemzése”)
    moduleIds: ['a1b2c3d4-0001-0101-0001-000000000001'],
    slugs: ['gyertyaminta-puska', 'gyertyaminta-atlasz'],
    ikon: '🕯️',
    linkSor: 'Valós BTC-grafikonok: melyik gyertyaminta ez, ezen a helyen?',
    forras: FORRAS,
    disclaimer: DISCLAIMER,
  },
};

export const ALAKZAT = KESZLETEK.alakzat;
export const GYERTYA = KESZLETEK.gyertya;

/** A segédlethez tartozó készlet („Interaktív változat”), vagy null. */
export const keszletSlughoz = (slug) => Object.values(KESZLETEK).find(k => k.slugs.includes(slug)) || null;

/** A modulkártya alatti linkek készletei. */
export const keszletekModulhoz = (moduleId) => Object.values(KESZLETEK).filter(k => k.moduleIds.includes(moduleId));
